<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M16 3a13 13 0 1 0 13 13h-2a11 11 0 1 1-1.8-6H20v2h8V4h-2v3.7A13 13 0 0 0 16 3Z"
    />
  </svg>
</template>
